<template>
  <div
    :class="{
      'rotating-border': docsUploaded,
      excluded: hoverCand == candidate.email && !type,
    }"
  >
    <div
      class="kanban-main-cards d-flex"
      :style="!tagFiltered && 'border-radius: 8px !important'"
    >
      <div class="w-15 position-relative">
        <div
          class="mr-2 position-relative"
          :class="
            showGrayTick && !candidate.onboarding
              ? 'avatar-gray-tick'
              : showWhiteTick && !candidate.onboarding
              ? 'avatar-blue-tick'
              : candidate.customFields &&
                candidate.customFields.imageMedia &&
                candidate.customFields.imageMedia != null
              ? 'common-sm-profile-transparet-icon'
              : 'common-sm-profile-icon'
          "
        >
          <template
            v-if="
              !triggerReport &&
              (!triggerCVS || candidate.cvsStatus == 2 || candidate.onboarding)
            "
          >
            <b-avatar
              v-if="
                candidate.customFields &&
                candidate.customFields.imageMedia &&
                candidate.customFields.imageMedia != null
              "
              :src="candidate.customFields.imageMedia"
            ></b-avatar>
            <b-avatar v-else :text="candidate.name[0].toUpperCase()"></b-avatar>
          </template>
          <b-avatar
            v-else-if="triggerReport"
            button
            @click="$emit('trigger-report-cand')"
            :src="getTriggerIcon"
          ></b-avatar>
          <b-avatar
            v-else
            button
            @click="$emit('trigger-cvs-cand')"
            :src="getTriggerIcon"
          ></b-avatar>
        </div>
        <!-- <img src="../../assets/img/newvendorflow/pushedcand.svg" alt="" /> -->
        <b-avatar
          v-if="addedByVendor"
          :text="getVendorName[1][0].toUpperCase()"
          v-b-tooltip.hover.bottom="`${getVendorName[0]}`"
          class="pushed-cand-avatar"
        ></b-avatar>
      </div>
      <div class="w-85">
        <div class="d-flex">
          <div class="w-75 text-truncate kanban-maincards-mainhead">
            {{ candidate.name }}
          </div>
          <div class="w-25 d-flex align-items-center position-relative">
            <img
              v-if="
                selectedCandidate.candidateID == candidate.candidateID &&
                viewCandidateModal
              "
              src="../../assets/img/newcreatejob/hideicon.svg"
              alt=""
              class="pointer"
            />
            <img
              v-else
              :class="isSchedule && 'disabled-kanban-img'"
              @click="!isSchedule && $emit('view-candidate')"
              src="../../assets/img/newkanban/view.svg"
              alt=""
              class="pointer"
            />
            <img
              @click.stop="
                isSchedule || jobOnHold
                  ? ''
                  : selectedID != candidate.candidateID
                  ? selectCand()
                  : closeCand()
              "
              tabindex="0"
              :class="(isSchedule || jobOnHold) && 'disabled-kanban-img'"
              class="ml-2 kanban-image-hover pointer"
              src="../../assets/img/newkanban/more.svg"
              alt=""
            />
            <div
              :ref="'closecard' + candidate.candidateID"
              class="kanban-more-option-card"
              v-if="selectedID == candidate.candidateID"
            >
              <!-- if the icon is schedule please check the assets/img/newkanban/moreoptionicons for all icons -->
              <div
                v-if="!candidate.onboarding"
                class="kanban-more-option-card-input"
                @click="$emit('schedule-interview')"
              >
                <img :src="getF2fIcon()" class="mr-1" alt="" />
                {{ candidate.kanbanScheduled ? "Reschedule" : "Schedule" }}
              </div>
              <div
                v-if="candidate.kanbanScheduled && !candidate.onboarding"
                class="kanban-more-option-card-input"
                @click="$emit('give-feedback')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/givefdbck.svg"
                  class="mr-1"
                  alt=""
                />
                Give Feedback
              </div>
              <div
                v-if="
                  candidate.kanbanScheduled &&
                  showCancelMeeting &&
                  !candidate.onboarding
                "
                class="kanban-more-option-card-input"
                @click="$emit('cancel-meeting')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/cancelmeeting.svg"
                  class="mr-1"
                  alt=""
                />
                Cancel Meeting
              </div>
              <div
                v-if="!candidate.onboarding"
                class="kanban-more-option-card-input"
                @click="$emit('on-hold')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/moveonhold.svg"
                  class="mr-1"
                  alt=""
                />
                Move to Onhold
              </div>
              <div
                v-if="
                  particularJob.positionIDs.length > 1 && !candidate.onboarding
                "
                class="kanban-more-option-card-input"
                @click="$emit('change-position')"
              >
                <img
                  src="../../assets/img/newkanban/change-position.svg"
                  class="mr-2"
                  alt=""
                />
                Change Position ID
              </div>
              <div
                class="kanban-more-option-card-input"
                @click="$emit('view-feedback')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/viewfdbck.svg"
                  class="mr-1"
                  alt=""
                />
                View Feedback
              </div>
              <div
                v-if="!candidate.onboarding"
                class="kanban-more-option-card-input"
                @click="$emit('not-interested')"
              >
                <img
                  src="../../assets/img/newkanban/moreoptionicons/ni.svg"
                  class="mr-1"
                  alt=""
                />
                Not Interested
              </div>
              <div
                v-if="!candidate.onboarding"
                @click="selectCand(true), (showStatus = !showStatus)"
                :style="showStatus && 'background: #E8EFF4 !important;'"
                class="kanban-more-option-card-input relativeclass"
                v-b-toggle.collapse-1
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <img
                      src="../../assets/img/newkanban/job-status.svg"
                      style="margin-right: 6px"
                      alt=""
                    />
                    Status
                  </div>
                  <img
                    v-if="showStatus"
                    src="../../assets/new-kanban-icons/up-arrow.svg"
                    class="mr-1"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/new-kanban-icons/down-arrow.svg"
                    class="mr-1"
                    alt=""
                  />
                </div>
              </div>
              <b-collapse id="collapse-1" class="status-collapse">
                <b-card class="card-set">
                  <ul>
                    <li
                      v-if="!candidate.onboarding"
                      @click="
                        type = 'onboard';
                        isOnboard = true;
                      "
                      class="status-dropdown-inner-container-unselected"
                    >
                      Candidate on-boarded
                    </li>
                    <li
                      v-if="
                        !candidate.offerletterIssued && !candidate.onboarding
                      "
                      @click="
                        type = 'letter';
                        isOnboard = true;
                      "
                      class="status-dropdown-inner-container-unselected"
                    >
                      Offer letter issued
                    </li>
                  </ul>
                </b-card>
              </b-collapse>
              <div
                @click="selectCand(true), (addAttach = !addAttach)"
                :style="
                  addAttach && 'background: rgb(200, 217, 229) !important;'
                "
                class="kanban-more-option-card-input relativeclass"
                v-b-toggle.collapse-2
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <img
                      src="../../assets/new-icons/attachment-icon.svg"
                      class="mr-1"
                      alt=""
                    />
                    Add Attachment
                  </div>
                  <img
                    v-if="addAttach"
                    src="../../assets/new-kanban-icons/up-arrow.svg"
                    class="mr-1"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/new-kanban-icons/down-arrow.svg"
                    class="mr-1"
                    alt=""
                  />
                </div>

                <!-- status-dropdown-inner-container-selected -- bind this -->
                <!-- <div class="status-dropdown-inner-container ml-2">
                    <div class="status-dropdown-inner-container-unselected" @click="
                      (addAttach = false),
                        $emit('show-add-attachment', candidate)"
                  >
                    Media
                    </div>
                    <div @click="
                      (addAttach = false), $emit('show-add-note', candidate)
                    " class="status-dropdown-inner-container-unselected">
                      Note
                    </div>
                  </div> -->
                <!-- </div> -->
              </div>
              <b-collapse id="collapse-2" class="status-collapse">
                <b-card class="card-set">
                  <ul>
                    <li
                      @click="
                        (addAttach = false),
                          $emit('show-add-attachment', candidate)
                      "
                      class="status-dropdown-inner-container-unselected"
                    >
                      Media
                    </li>
                    <li
                      @click="
                        (addAttach = false), $emit('show-add-note', candidate)
                      "
                      class="status-dropdown-inner-container-unselected"
                    >
                      Note
                    </li>
                  </ul>
                </b-card>
              </b-collapse>
              <div
                v-if="
                  candidate.onboardingDocument != null &&
                  roles.includes('VIEW_ONBOARDING_DOCS')
                "
                class="kanban-more-option-card-input text-truncate"
                @click="closeCand(), $emit('view-finaldocs')"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt=""
                />
                {{ showViewDocs ? "View" : "Review" }} Documents
              </div>
              <div
                v-if="
                  candidate.onboardingDocument == null &&
                  roles.includes('REQ_ONBOARDING_DOCS')
                "
                class="kanban-more-option-card-input text-truncate"
                @click="closeCand(), $emit('request-finaldocs')"
              >
                <img
                  src="../../assets/img/newkanban/reviewdocuments.svg"
                  class="mr-2"
                  alt=""
                />
                Request Documents
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center w-100">
          <img src="../../assets/img/newkanban/mail.svg" alt="" />
          <span class="w-70 text-truncate kanban-maincards-mailncall ml-1">
            {{ candidate.email }}
          </span>
        </div>
        <div class="mt-1 w-100">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div
              class="tip-learn-more font-lato"
              v-if="triggerCVS && candidate.cvsStatus == 2"
            >
              CVS Score:
              <span class="fw-600">{{
                candidate.cvsScore ? `${candidate.cvsScore}/50` : "0/50"
              }}</span>
            </div>
            <div v-else class="kanban-maincards-mailncall">
              <img src="../../assets/img/newkanban/phone.svg" alt="" />
              {{ candidate.phoneNumber }}
            </div>
            <img
              v-if="candidate.onboarding"
              :class="!triggerCVS && 'ml-5'"
              src="../../assets/img/newkanban/onboarded.svg"
              alt=""
              v-b-tooltip.hover.bottom.html="{
                customClass: 'onboarding-tooltip',

                title: candidate.onboardingDate
                  ? `<div class='tooltip-content'>
                      <div>Candidate on-boarded</div>
                      <div>Onboarded Date: ${convertDateFormat(
                        candidate.onboardingDate
                      )}</div>
                    </div>`
                  : 'Candidate on-boarded',
              }"
            />
            <img
              v-else-if="candidate.offerletterIssued"
              :class="!triggerCVS && 'ml-5'"
              src="../../assets/img/newkanban/job-status.svg"
              alt=""
              v-b-tooltip.hover.bottom="'Offer letter issued'"
            />
            <div
              v-if="candidate.processing"
              class="kanban-maincards-processing"
              style="color: #20639b"
            >
              Processing
            </div>
            <div
              v-else-if="triggerReport"
              class="kanban-maincards-nottriggered"
              :style="reportStatus.style"
              v-b-tooltip.hover.bottom="reportStatus.tooltip"
            >
              {{ reportStatus.label }}
            </div>
            <div
              v-else-if="triggerCVS"
              class="kanban-maincards-nottriggered"
              :style="
                candidate.cvsStatus == 1
                  ? 'color: #8C8C8C;'
                  : candidate.cvsStatus == 2
                  ? 'color: #038E00;'
                  : 'color: #20639B;'
              "
            >
              {{ getCVSStatus }}
            </div>
            <div
              v-else-if="candidate.ranking"
              class="kanban-maincards-nottriggered"
            >
              <img src="../../assets/img/newkanban/AI-icon.svg" alt="" />
              <span class="ml-1" :style="'color: #038E00;'"
                >Rank #{{ candidate.ranking }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      ref="container"
      v-if="
        !type &&
        tagFiltered &&
        candidate.customFields.notesTags &&
        candidate.customFields.notesTags.length != 0
      "
      class="kanbancard-tags-container d-flex align-items-center gap-10"
    >
      <div
        v-for="(tag, index) in visibleTags"
        :key="index"
        class="kanbancards-skilltags fs-12 fw-400 font-lato color-mainblue"
        :style="
          visibleTags.length == 1 &&
          (remainingCount > 1 ||
            (remainingCount === 1 && visibleTags.length > 0)) &&
          'max-width: 195px !important;'
        "
        :class="visibleTags.length == 1 && 'kanban-tag-truncate'"
      >
        #{{ tag }}
      </div>

      <div
        :ref="'showmoreskills' + candidate.candidateID"
        v-if="
          remainingCount > 1 || (remainingCount === 1 && visibleTags.length > 0)
        "
        :id="'showmoreskills' + candidate.candidateID"
        class="
          kanbancards-skilltags
          fs-12
          fw-400
          font-lato
          color-mainblue
          pointer
        "
      >
        +{{ remainingCount }} more
      </div>
      <b-tooltip
        @shown="onTooltipShown"
        ref="tooltip"
        :target="'showmoreskills' + candidate.candidateID"
        triggers="click"
        placement="bottom"
        @hidden="$emit('show-blur', false)"
        :id="'tooltip' + candidate.candidateID"
        :custom-class="'kanban-skill-tooltip'"
      >
        <template
          v-if="candidate.notes && Object.keys(candidate.notes).length != 0"
        >
          <div class="fs-12 fw-600 font-mont color-e0e0e0">
            {{ candidate.notes.noteCreatedBy }}
            <span class="color-abb1b9 fs-11 fw-500 font-lato font-italic">
              ({{ candidate.notes.createdAt }})
            </span>
          </div>
          <div class="font-mont fw-500 fs-12 color-white mt-1">
            {{ candidate.notes.note }}
          </div>
        </template>

        <div
          ref="tooltipTags"
          class="mt-2 d-flex align-items-center gap-10 flex-wrap"
        >
          <div
            v-for="(tag, index) in visibleSubTags"
            :key="index"
            class="kanbancards-skilltags fs-12 fw-400 font-lato color-mainblue"
          >
            #{{ tag }}
          </div>
          <div
            @click="$emit('view-candidate', 'show-note')"
            v-if="count > 0"
            class="
              kanbancards-skilltags
              fs-12
              fw-400
              font-lato
              color-mainblue
              pointer
            "
          >
            +{{ count }} more
          </div>
        </div>
      </b-tooltip>
    </div>
    <KanbanCommentModal
      v-if="isOnboard"
      :type="type"
      :label="'Comments'"
      :showAddComment="isOnboard"
      :heading="heading"
      :remarksRequired="true"
      @close-modal="closeOnBoard"
      @btn2-action="btn2Action"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KanbanCommentModal from "../Kanban/modal/KanbanCommentModal.vue";
import { candIsOnBoarded } from "../../utils/apiFunctions";
import toast from "../mixin/toast";
import {
  getCVSStatus,
  showWhiteTick,
  showGrayTick,
  getTriggerIcon,
  calculateVisibleSubTags,
  calculateVisibleTags,
  removeTooltip,
} from "./kanbanHelpers";
import { convertDateFormat } from "../../controllers/commonHelpers";

export default {
  data() {
    return {
      showStatus: false,
      hovered: null,
      addAttach: false,
      isOnboard: false,
      type: null,
      visibleTags: [],
      remainingCount: 0,
      visibleSubTags: [],
      count: 0,
    };
  },
  mixins: [toast],
  props: {
    candidate: Object,
    isSchedule: Boolean,
    jobOnHold: Boolean,
    selectedID: String,
    selectedCandidate: Object,
    viewCandidateModal: Boolean,
    particularJob: Object,
    triggerCVS: Boolean,
    triggerReport: Boolean,
    triggerCands: Array,
    tagFiltered: Boolean,
    hoverCand: String,
  },
  components: { KanbanCommentModal },
  watch: {
    hoverCand(val) {
      if (val == this.candidate.candidateID) {
        this.$refs.tooltip.$emit("open");
      }
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
    }),
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters({ roles: "roles" }),
    docsUploaded() {
      return (
        [2, 4].includes(this.candidate.onboardingDocument) &&
        this.roles.includes("REVIEW_ONBOARDING_DOCS") &&
        this.roles.includes("VIEW_ONBOARDING_DOCS")
      );
    },
    showViewDocs() {
      return (
        !this.roles.includes("REVIEW_ONBOARDING_DOCS") ||
        ![2, 4].includes(this.candidate.onboardingDocument)
      );
    },
    getVendorName() {
      var id;
      if (
        this.candidate.customerID[this.particularJob.customerID][
          this.particularJob.jobID
        ].pushedBy
      ) {
        id =
          this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].pushedBy;
      } else {
        id = this.candidate.createdBy;
      }
      let name = this.projectUsers[id].username;
      let text = `Pushed by vendor "${name}"`;
      return [text, name];
    },
    addedByVendor() {
      if (this.particularJob) {
        if (
          this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].addedByVendor
        ) {
          return this.candidate.customerID[this.particularJob.customerID][
            this.particularJob.jobID
          ].addedByVendor;
        }
      }
      return false;
    },
    showCancelMeeting() {
      if (this.candidate.cancelMeeting) {
        return this.checkAccess(this.candidate.scheduledUsing);
      }
      return false;
    },
    heading() {
      if (this.type == "letter") {
        return "Offer letter issued";
      } else {
        return "Candidate on-boarded";
      }
    },
    getCVSStatus() {
      return getCVSStatus(this.candidate);
    },
    getTriggerIcon() {
      return getTriggerIcon(this);
    },
    reportStatus() {
      if (this.candidate.reportUpdateAvailable)
        return {
          label: "Update available",
          style: "color: #038E00;",
          tooltip: "CVS was taken after this report was generated",
        };
      if (!this.candidate.reportKey)
        return {
          label: "No report",
          style: "color: #20639B;",
          tooltip: "No match report generated yet",
        };
      return {
        label: this.candidate.recommendation
          ? this.verdictLabel(this.candidate.recommendation)
          : "View Report",
        style: this.candidate.recommendation
          ? this.verdictColor(this.candidate.recommendation)
          : "color: #8C8C8C;",
        tooltip: "Report reflects all available evidence",
      };
    },
    showWhiteTick() {
      return showWhiteTick(this);
    },
    showGrayTick() {
      return showGrayTick(this);
    },
  },
  mounted() {
    document.addEventListener("click", this.closeOnOutside);
    if (
      !this.type &&
      this.candidate.customFields.notesTags &&
      this.candidate.customFields.notesTags.length != 0
    ) {
      this.calculateVisibleTags();
      this.calculateVisibleSubTags(this.candidate.customFields.notesTags);
      window.addEventListener("resize", this.calculateVisibleTags);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOnOutside);
    if (
      !this.type &&
      this.candidate.customFields.notesTags &&
      this.candidate.customFields.notesTags.length != 0
    ) {
      window.removeEventListener("resize", this.calculateVisibleTags);
    }
  },
  methods: {
    verdictLabel(rec) {
      if (rec.fit) return rec.fit.band;
      const map = { ADVANCE: "Strong Fit", HOLD: "Review", REJECT: "No Fit" };
      return (rec && map[rec.decision]) || "View Report";
    },
    verdictColor(rec) {
      const token = rec && rec.fit && rec.fit.token;
      if (token) {
        const tokenColors = {
          good: "#038e00",
          warn: "#ffc145",
          crit: "#eb0002",
          neu: "#5a6472",
        };
        return `color: ${tokenColors[token] || "#5a6472"}`;
      }
      const decision = rec && rec.decision;
      if (decision === "ADVANCE") return "color: #038e00";
      if (decision === "REJECT") return "color: #eb0002";
      return "color: #ffc145";
    },
    convertDateFormat(dateStr) {
      return convertDateFormat(dateStr);
    },
    onTooltipShown() {
      this.$emit("show-blur", true);
    },
    calculateVisibleTags() {
      calculateVisibleTags(this);
    },
    calculateVisibleSubTags(tags) {
      calculateVisibleSubTags(tags, this);
    },
    async btn2Action(remarks, date) {
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          candidateID: this.candidate.candidateID,
          remarks: remarks,
        };
        if (this.type === "onboard") {
          payload.onboarding = true;
          if (date) payload.onboardingDate = date;
        } else if (this.type === "letter") {
          payload.offerletter = true;
          if (date) payload.date = date;
        }
        const res = await candIsOnBoarded(payload);
        if (res.status == 200) {
          var text;
          var title;
          if (this.type == "letter") {
            text = `Offer letter has been issued to candidate "${this.candidate.name}".`;
            title = "Offer Letter Issued";
          } else {
            text = `Candidate "${this.candidate.name}" has been on-boarded`;
            title = "Successfully On-Boarded";
          }
          this.dynamicToast("success", title, text);
          this.type = null;
          this.closeOnBoard();
          this.$emit("update-details");
        } else {
          this.type = null;
          this.closeOnBoard();
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.type = null;
        this.closeOnBoard();
        this.errorModal("Something went wrong");
      }
    },
    closeOnBoard() {
      this.isOnboard = false;
    },
    checkAccess(id) {
      let val = this.thirdPartyData.data.find((obj) => obj.thirdPartyID === id);
      if (!val) {
        return false;
      }
      return val.enabled;
    },
    selectCand(val) {
      if (!this.type && this.hoverCand == this.candidate.email)
        this.removeTooltip();
      this.$emit("select-cand", this.candidate.candidateID);
      if (!val) {
        this.addAttach = false;
        this.showStatus = false;
      }
    },
    closeCand() {
      this.$emit("select-cand", "");
      this.addAttach = false;
      this.showStatus = false;
    },
    getF2fIcon() {
      if (this.candidate.kanbanScheduled) {
        return require("../../assets/img/newkanban/moreoptionicons/reschedule.svg");
      }
      return require("../../assets/img/newkanban/moreoptionicons/schedule.svg");
    },
    removeTooltip() {
      removeTooltip(this);
    },
    closeOnOutside(event) {
      let id = "closecard" + this.candidate.candidateID;
      if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
        this.$emit("select-cand", "");
        this.addAttach = false;
        this.showStatus = false;
        // Close the dropdown
      }
      if (!this.type) {
        const triggerRef =
          this.$refs["showmoreskills" + this.candidate.candidateID];
        // const tooltipEl = document.getElementById("tooltip-" + this.candidate.candidateID);
        // If click is outside both the trigger and the tooltip, close
        if (triggerRef && !triggerRef.contains(event.target)) {
          this.removeTooltip();
        }
      }
      // if(tooltipEl &&
      //   !tooltipEl.contains(event.target)){
      //     tooltipEl &&
      //   !tooltipEl.contains(event.target)
      //   }
    },
  },
};
</script>

<style scoped>
.kanban-maincards-processing {
  padding: 3px 10px;
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-style: italic;
  font-size: 12px;
  background: #f6f9fb;
  border-radius: 8px;
  display: flex;
  justify-content: center;
}
.onboarding-tooltip .tooltip-inner {
  /* max-width: 500px !important; */
  white-space: normal;
  text-align: left;
}

.tooltip-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.rotating-border {
  position: relative;
  width: 100%;
  border-radius: 8px;
  background-size: 300% 300%;
  animation: rotate-gradient 1s linear infinite; /* Rotate the gradient */
  padding: 3px; /* Space for the border */
}

/* Animation for the gradient rotation */
@keyframes rotate-gradient {
  0% {
    background-position: 0% 5%;
    background: linear-gradient(0deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  5% {
    background-position: 5% 10%;
    background: linear-gradient(18deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  10% {
    background-position: 10% 15%;
    background: linear-gradient(36deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  15% {
    background-position: 15% 20%;
    background: linear-gradient(54deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  20% {
    background-position: 20% 25%;
    background: linear-gradient(72deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  25% {
    background-position: 25% 30%;
    background: linear-gradient(90deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  30% {
    background-position: 30% 35%;
    background: linear-gradient(108deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  35% {
    background-position: 35% 40%;
    background: linear-gradient(126deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  40% {
    background-position: 40% 45%;
    background: linear-gradient(144deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  45% {
    background-position: 45% 50%;
    background: linear-gradient(162deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  50% {
    background-position: 50% 55%;
    background: linear-gradient(180deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  55% {
    background-position: 55% 60%;
    background: linear-gradient(198deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  60% {
    background-position: 60% 65%;
    background: linear-gradient(216deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  65% {
    background-position: 65% 70%;
    background: linear-gradient(234deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  70% {
    background-position: 70% 75%;
    background: linear-gradient(252deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  75% {
    background-position: 75% 80%;
    background: linear-gradient(270deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  80% {
    background-position: 80% 85%;
    background: linear-gradient(288deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  85% {
    background-position: 85% 90%;
    background: linear-gradient(306deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  90% {
    background-position: 90% 95%;
    background: linear-gradient(324deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  95% {
    background-position: 95% 100%;
    background: linear-gradient(342deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
  100% {
    background-position: 100% 0%;
    background: linear-gradient(360deg, #20639b, #ffffff, #ffffff);
    /* transition: all 0.3s linear; */
  }
}
</style>
